import React, { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { BrowserRouter as Router, Route, Routes, useParams, useNavigate } from "react-router-dom";
import Header from "./components/Header/Header";
import Menu from "./components/Menu/Menu";
import ProductGrid from "./components/ProductGrid/ProductGrid";
import ProductDetail from "./components/ProductDetail/ProductDetail";
import Footer from "./components/Footer/Footer";
import "./App.css";

function MainApp() {
  const [mainMenuCategories, setMainMenuCategories] = useState([]);
  const [fashionCategories, setFashionCategories] = useState([]);
  const [moreCategories, setMoreCategories] = useState([]);
  const [products, setProducts] = useState([]); // Add products state here

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchCategories(endpoint, setter) {
      try {
        const data = await API.get("DealsSiteAPI", endpoint, {});
        setter(data);
      } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
      }
    }
    fetchCategories("/api/main-menu-categories", setMainMenuCategories);
    fetchCategories("/api/fashion-categories", setFashionCategories);
    fetchCategories("/api/more-categories", setMoreCategories);
  }, []);

  return (
    <div className="App">
      <Header />
      <Menu
        mainMenuCategories={mainMenuCategories}
        fashionCategories={fashionCategories}
        moreCategories={moreCategories}
        setSelectedCategory={(newCategory) => navigate(`/category/${newCategory}`)}
      />

      <Routes>
        <Route path="/" element={<CategoryPage products={products} setProducts={setProducts} />} />
        <Route path="/category/:category" element={<CategoryPage products={products} setProducts={setProducts} />} />
        <Route
          path="/product/:asin"
          element={<ProductDetail products={products} />} // Pass products as a prop
        />
      </Routes>

      <Footer />
    </div>
  );
}

function CategoryPage({ products, setProducts }) {
  const { category } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchURL, setSearchURL] = useState("");

  useEffect(() => {
    async function fetchDeals() {
      try {
        setLoading(true);
        setError(null);
        const categoryToFetch = category || "hotdeals";
        const data = await API.get("DealsSiteAPI", `/api/deals/${categoryToFetch}`, {});
        setProducts(data.deals || []); // Update products state
        setSearchURL(data.SearchURL || "");
        setLoading(false);
      } catch (error) {
        console.error("Error fetching deals:", error);
        setError("Failed to load deals. Please try again later.");
        setLoading(false);
      }
    }
    fetchDeals();
  }, [category, setProducts]);

  return (
    <>
      <div className="section-title">
        <h2>{category ? `Top deals ${category} ` : "Top Amazon Deals"}</h2>
      </div>
      <ProductGrid products={products} loading={loading} error={error} searchURL={searchURL} />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<MainApp />} />
      </Routes>
    </Router>
  );
}

export default App;